<template>
  <div class="fluid grid-list-xl">
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
        <section class="bg-home" id="home">
            <div class="home-center">
                <div class="home-desc-center">
                    <div style="margin-left: 9%;margin-right: 9%;">
                        <div class="row mt-5">
                            <div class="col-lg-7">
                                <div class="home-title text-white">
                                    <h5 class="mb-3 text-white text-opacity-50">Assur'Cloud</h5>
                                    <h1>{{ $t('plateforme.title') }}</h1>
                                    <p class="mt-4 text-white text-opacity-50" style="font-size: 20px!important;">
                                      {{ $t('plateforme.paragraphe_content[0]') }}
                                    </p>
                                    <v-btn class="btn-toggle" @click="toggle()" flat small ref="btnPlusDesktip">Voir Plus</v-btn>
                                    <p v-show="!isHidden" class="mt-4 text-white text-opacity-50 f-16" style="font-size: 20px!important;">{{ $t('plateforme.paragraphe_content[1]') }}</p>
                                    <div class="row mt-4">
                                    <div class="col-sm-12">
                                      <button @click="goToDemo()" class="animate-demo-button btn btn-md btn-primary" type="button">{{ $t('plateforme.demo_button_label') }}</button>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-5">
                                <img src="../../assets/img/plateform/web-3.svg" alt="" class="img-fluid mx-auto d-block">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg-light" id="features">
            <div style="margin-left: 9%;margin-right: 9%;">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="features-img">
                            <img src="../../assets/img/plateform/admin.png" alt="" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                     <div class="col-lg-6">
                        <div class="feautures-content ps-lg-5">
                            <div class="icon-bg-text rounded d-flex justify-content-center align-items-center flex-shrink-0 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" size="20" class="tabler-icon tabler-icon-mood-happy fs-5 text-white"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M9 9l.01 0"></path><path d="M15 9l.01 0"></path><path d="M8 13a4 4 0 1 0 8 0h-8"></path></svg>
                            </div>
                            <div>
                                <h1 class="lh-base">{{ $t('plateforme.premiere_step_title') }}</h1>
                                <h5>{{ $t('plateforme.premiere_step_content[0]') }}</h5>
                                <p class="text-muted">{{ $t('plateforme.premiere_step_content[1]') }}</p>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

         <section class="bg-light" id="features">
            <div style="margin-left: 9%;margin-right: 9%;">
                <div class="row align-items-center">
                     <div class="col-lg-6">
                        <div class="feautures-content ps-lg-5">
                            <div class="icon-bg-text rounded d-flex justify-content-center align-items-center flex-shrink-0 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" size="20" class="tabler-icon tabler-icon-mood-happy fs-5 text-white"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M9 9l.01 0"></path><path d="M15 9l.01 0"></path><path d="M8 13a4 4 0 1 0 8 0h-8"></path></svg>
                            </div>
                            <div>
                                <h1 class="lh-base">{{ $t('plateforme.deuxieme_step_title') }}</h1>
                                <p class="text-muted">{{ $t('plateforme.deuxieme_step_content[0]') }}</p>                                
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="features-img">
                            <img src="../../assets/img/plateform/enjoy.png" alt="" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                   
                </div>
            </div>
        </section>

        <section>
          <div class="mt-5 pt-5 mb-5 pb-5" style="margin-left: 9%;margin-right: 9%;">
            <div class="row justify-content-between align-items-center">
              <div class="col-lg-5">
                <h1 class="lh-base">{{ $t('plateforme.troisieme_step_title') }}</h1>
                <p class="text-muted">{{ $t('plateforme.troisieme_step_content[0]') }}</p>

                 <div class="col-sm-12">
                    <button @click="goToDemo()" class="animate-demo-button btn btn-md btn-primary" type="button">{{ $t('plateforme.demo_button_label') }}</button>
                </div>
              </div>
              <div class="col-lg-7">
                <div class="row g-3">
                  <div class="col-lg-6">
                    <div class="card bg-secondary bg-shape" style="border-radius: 10px;height: 125px;"><!----><!----><!---->
                      <div class="card-body"><!----><!---->
                        <h4 class="text-white" style="font-weight: 400;font-size: 20px;">{{ $t('plateforme.un_card_title') }}</h4>
                        <p class="text-dark-50" style="font-size: 15px;color: #fff;">{{ $t('plateforme.un_card_content[0]') }}</p>
                      </div><!----><!---->
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="card bg-secondary bg-shape border-0" style="border-radius: 10px;height: 125px;"><!----><!----><!---->
                      <div class="card-body"><!----><!---->
                       <h4 class="text-white" style="font-weight: 500;font-size: 20px;">{{ $t('plateforme.deux_card_title') }}</h4>
                        <p class="text-dark-50" style="font-size: 15px;color: #fff;">{{ $t('plateforme.deux_card_content[0]') }}</p>
                      </div><!----><!---->
                    </div>
                  </div>
                </div>
                <div class="row g-3 mt-4">
                  <div class="col-lg-6">
                    <div class="card bg-secondary bg-shape border-" style="border-radius: 10px;height: 125px;"><!----><!----><!---->
                      <div class="card-body"><!----><!---->
                        <h4 class="text-white" style="font-weight: 500;font-size: 20px;">{{ $t('plateforme.trois_card_title') }}</h4>
                        <p class="text-dark-50" style="font-size: 15px;color: #fff;">{{ $t('plateforme.trois_card_content[0]') }}</p>
                      </div><!----><!---->
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="card bg-secondary bg-shape border-0" style="border-radius: 10px;height: 125px;"><!----><!----><!---->
                      <div class="card-body"><!----><!---->
                       <h4 class="text-white" style="font-weight: 500;font-size: 20px;">{{ $t('plateforme.quatre_card_title') }}</h4>
                        <p class="text-dark-50" style="font-size: 15px;color: #fff;">{{ $t('plateforme.quatre_card_content[0]') }}</p>
                      </div><!----><!---->
                    </div>
                  </div>
                </div>
                <div class="row g-3 mt-4">
                  <div class="col-lg-12">
                    <div class="card bg-secondary bg-shape border-" style="border-radius: 10px;"><!----><!----><!---->
                      <div class="card-body"><!----><!---->
                        <h4 class="text-white" style="font-weight: 500;font-size: 20px;">{{ $t('plateforme.cinq_card_title') }}</h4>
                        <p class="text-dark-50" style="font-size: 15px;color: #fff;">{{ $t('plateforme.cinq_card_content[0]') }}</p>
                      </div><!----><!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="bg-light" id="features">
            <div style="margin-left: 9%;margin-right: 9%;">
                <div class="row align-items-center">
                     <div class="col-lg-6">
                        <div class="feautures-content ps-lg-5">
                            <div class="icon-bg-text rounded d-flex justify-content-center align-items-center flex-shrink-0 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" size="20" class="tabler-icon tabler-icon-mood-happy fs-5 text-white"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M9 9l.01 0"></path><path d="M15 9l.01 0"></path><path d="M8 13a4 4 0 1 0 8 0h-8"></path></svg>
                            </div>
                            <div>
                                <h1 class="lh-base">{{ $t('plateforme.quatrieme_step_title') }}</h1>
                                <p class="text-muted">{{ $t('plateforme.quatrieme_step_content[0]') }}</p>                                
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="features-img">
                            <img src="../../assets/img/plateform/features.png" alt="" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                   
                </div>
            </div>
        </section>

         <section class="bg-light" id="features">
            <div style="margin-left: 9%;margin-right: 9%;">
                <div class="pb-5 row align-items-center">
                    <div class="col-lg-6">
                        <div class="features-img">
                            <img src="../../assets/img/plateform/features-1.png" alt="" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                     <div class="col-lg-6">
                        <div class="feautures-content ps-lg-5">
                            <div class="icon-bg-text rounded d-flex justify-content-center align-items-center flex-shrink-0 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" size="20" class="tabler-icon tabler-icon-mood-happy fs-5 text-white"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M9 9l.01 0"></path><path d="M15 9l.01 0"></path><path d="M8 13a4 4 0 1 0 8 0h-8"></path></svg>
                            </div>
                            <div>
                                <h1 class="lh-base">{{ $t('plateforme.cinquieme_step_title') }}</h1>
                                <p class="text-muted">{{ $t('plateforme.cinquieme_step_content[0]') }}</p>                                
                            </div>
                        </div>

                         <div class="col-sm-12">
              <button @click="goToDemo()" class="animate-demo-button btn btn-md btn-primary" type="button">{{ $t('plateforme.demo_button_label') }}</button>
            </div>
                    </div>
                </div>
            </div>
        </section>
      </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.sm.xs class="margin_section">
        <section class="bg-home" id="home">
            <div class="home-center">
                <div class="home-desc-center">
                    <div class="container">
                        <div class="row ml-2 mr-2">
                            <div class="col-lg-12">
                                <div class="home-title text-white">
                                    <h5 class="mb-3 text-white text-opacity-50">Assur'Cloud</h5>
                                    <h2>{{ $t('plateforme.title') }}</h2>
                                    <p class="mt-4 text-white text-opacity-50" style="font-size: 15px!important;"> {{ $t('plateforme.paragraphe_content[0]') }}</p>
                                    <v-btn class="btn-toggle-mobile" @click="toggle()" flat small ref="btnPlusMobile">Voir Plus</v-btn>
                                    <p v-show="!isHidden" class="mt-4 text-white text-opacity-50" style="font-size: 15px!important;">{{ $t('plateforme.paragraphe_content[0]') }}</p>
                                </div>
                            </div>

                             <div class="row mt-5 ml-2 mr-2">
                                      <div class="col-sm-12">
                                        <button @click="goToDemo()" class="animate-demo-button btn btn-md btn-primary" type="button">{{ $t('plateforme.demo_button_label') }}</button>
                                      </div>
                                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg-light" id="features">
            <div class="container">
                <div class="row align-items-center justify-content-between g-3 ml-3 mr-3" style="margin-top: 5%;">
                    <div class="col-lg-6">
                        <div class="feautures-content ps-lg-5">
                            <div class="icon-bg-text rounded d-flex justify-content-center align-items-center flex-shrink-0 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" size="20" class="tabler-icon tabler-icon-mood-happy fs-5 text-white"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M9 9l.01 0"></path><path d="M15 9l.01 0"></path><path d="M8 13a4 4 0 1 0 8 0h-8"></path></svg>
                            </div>
                            <div>
                                <h3 class="lh-base">{{ $t('plateforme.premiere_step_title') }}</h3>
                                <h5>{{ $t('plateforme.premiere_step_content[0]') }}</h5>
                                <p class="text-muted">{{ $t('plateforme.premiere_step_content[1]') }}</p>                                
                            </div>

                            <div class="features-img">
                                <img src="../../assets/img/plateform/admin.png" alt="" class="img-fluid mx-auto d-block">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg-light" id="features">
            <div class="container">
                <div class="row align-items-center ml-3 mr-3">
                     <div class="col-lg-6">
                        <div class="feautures-content ps-lg-5">
                            <div class="icon-bg-text rounded d-flex justify-content-center align-items-center flex-shrink-0 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" size="20" class="tabler-icon tabler-icon-mood-happy fs-5 text-white"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M9 9l.01 0"></path><path d="M15 9l.01 0"></path><path d="M8 13a4 4 0 1 0 8 0h-8"></path></svg>
                            </div>
                            <div>
                                <h3 class="lh-base">{{ $t('plateforme.deuxieme_step_title') }}</h3>
                                <p class="text-muted">{{ $t('plateforme.deuxieme_step_content[0]') }}</p>                                
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="features-img">
                            <img src="../../assets/img/plateform/enjoy.png" alt="" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                   
                </div>
            </div>
        </section>

        <section class="services-section" id="services">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-7">
                <div class="title ml-3 mb-5">
                  <h3>{{ $t('plateforme.troisieme_step_title') }}</h3>
                  <p class="text-muted">{{ $t('plateforme.troisieme_step_content[0]') }}</p>
                </div>
              </div>
            </div>
            <div class="row ml-2 mr-2 g-4">
              <div class="col-lg-3">
                <div class="p-3 rounded bg-light card-services-height">
                  <span class="icon-bg text-primary rounded d-flex justify-content-center align-items-center border border-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tabler-icon tabler-icon-brand-asana fs-4"><path d="M12 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path><path d="M17 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path><path d="M7 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path></svg>
                  </span>
                  <h6 class="mt-4 text-dark">{{ $t('plateforme.un_card_title') }}</h6>
                  <p class="text-muted">{{ $t('plateforme.un_card_content[0]') }}</p>
                </div>
              </div>
              <div class="col-lg-3 mt-4">
                <div class="p-3 rounded bg-light card-services-height">
                  <span class="icon-bg text-primary rounded d-flex justify-content-center align-items-center border border-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tabler-icon tabler-icon-pencil-discount fs-4"><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path><path d="M13.5 6.5l4 4"></path><path d="M16 21l5 -5"></path><path d="M21 21v.01"></path><path d="M16 16v.01"></path></svg>
                  </span>
                  <h6 class="mt-4 text-dark">{{ $t('plateforme.deux_card_title') }}</h6>
                  <p class="text-muted">{{ $t('plateforme.deux_card_content[0]') }}</p>
                </div>
              </div>
              <div class="col-lg-3 mt-4">
                <div class="p-3 rounded bg-light card-services-height">
                  <span class="icon-bg text-primary rounded d-flex justify-content-center align-items-center border border-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tabler-icon tabler-icon-pencil-discount fs-4"><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path><path d="M13.5 6.5l4 4"></path><path d="M16 21l5 -5"></path><path d="M21 21v.01"></path><path d="M16 16v.01"></path></svg>
                  </span>
                  <h6 class="mt-4 text-dark">{{ $t('plateforme.trois_card_title') }}</h6>
                  <p class="text-muted">{{ $t('plateforme.trois_card_content[0]') }}</p>
                </div>
              </div>
              <div class="col-lg-3 mt-4">
                <div class="p-3 rounded bg-light card-services-height">
                  <span class="icon-bg text-primary rounded d-flex justify-content-center align-items-center border border-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tabler-icon tabler-icon-user fs-4"><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path><path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path></svg>
                  </span>
                  <h6 class="mt-4 text-dark">{{ $t('plateforme.quatre_card_title') }}</h6>
                  <p class="text-muted">{{ $t('plateforme.quatre_card_content[0]') }}</p>
                </div>
              </div>
              <div class="col-lg-3 mt-4">
                <div class="p-3 rounded bg-light bg-shape">
                  <span class="icon-bg text-primary rounded d-flex justify-content-center align-items-center border border-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tabler-icon tabler-icon-user fs-4"><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path><path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path></svg>
                  </span>
                  <h6 class="mt-4 text-dark">{{ $t('plateforme.cinq_card_title') }}</h6>
                  <p class="text-muted">{{ $t('plateforme.cinq_card_content[0]') }}</p>
                </div>
              </div>
            </div>

            <div class="row mt-4 ml-2">
              <div class="col-sm-12">
                <button @click="goToDemo()" class="animate-demo-button btn btn btn-md btn-primary" type="button">{{ $t('plateforme.demo_button_label') }}</button>
              </div>
            </div>
          </div>
        </section>

        <section class="bg-light" id="features">
            <div class="container">
                <div class="ml-3 mr-3 row align-items-center justify-content-between g-3" style="margin-top: 5%;">
                    <div class="col-lg-6">
                        <div class="feautures-content ps-lg-5">
                            <div class="icon-bg-text rounded d-flex justify-content-center align-items-center flex-shrink-0 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" size="20" class="tabler-icon tabler-icon-mood-happy fs-5 text-white"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M9 9l.01 0"></path><path d="M15 9l.01 0"></path><path d="M8 13a4 4 0 1 0 8 0h-8"></path></svg>
                            </div>
                            <div>
                                <h3 class="lh-base">{{ $t('plateforme.quatrieme_step_title') }}</h3>
                                <p class="text-muted">{{ $t('plateforme.quatrieme_step_content[0]') }}</p>                                
                            </div>
                        </div>

                        <!-- <div class="row mt-4">
                            <div class="col-sm-12">
                                <button @click="goToDemo()" class="btn btn-md btn-primary" type="button"> Demander une Démo </button>
                            </div>
                        </div> -->
                    </div>
                    <div class="col-lg-5">
                        <div class="features-img">
                          <img src="../../assets/img/plateform/features.png" alt="business-work" class="mx-auto d-block img-fluid rounded">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg-light" id="features">
            <div class="container">
                <div class="mb-5 ml-3 mr-3 row align-items-center justify-content-between g-3" style="margin-top: 5%;">
                    <!-- <div class="col-lg-5">
                        <div class="img-part-3 bg-primary p-2 rounded">
                          <img src="../../assets/img/plateform/business-work.jpg" alt="business-work" class="mx-auto d-block img-fluid rounded">
                        </div>
                    </div> -->
                    <div class="col-lg-6">
                        <div class="feautures-content ps-lg-5">
                            <div class="icon-bg-text rounded d-flex justify-content-center align-items-center flex-shrink-0 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" size="20" class="tabler-icon tabler-icon-mood-happy fs-5 text-white"><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M9 9l.01 0"></path><path d="M15 9l.01 0"></path><path d="M8 13a4 4 0 1 0 8 0h-8"></path></svg>
                            </div>
                            <div>
                                <h3 class="lh-base">{{ $t('plateforme.cinquieme_step_title') }}</h3>
                                <p class="text-muted">{{ $t('plateforme.cinquieme_step_content[0]') }}</p>                                
                            </div>
                        </div>

                          <div class="col-lg-5">
                        <div class="features-img">
                          <img src="../../assets/img/plateform/features-1.png" alt="business-work" class="mx-auto d-block img-fluid rounded">
                        </div>
                    </div>
                        <div class="row mt-4">
                            <div class="col-sm-12">
                                <button @click="goToDemo()" class="animate-demo-button btn btn btn-md btn-primary" type="button">{{ $t('plateforme.demo_button_label') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
</template>

<script>
export default {
  name: 'plateform',

  data: () => ({
    title: 'Assuraf | Plateforme',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    isHidden : true,
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },
  methods : {
    toggle() {
        this.isHidden = !this.isHidden;
            if (this.isHidden===false){
                this.$refs.btnPlusDesktip.$el.innerText = "Voir Moins";
                this.$refs.btnPlusMobile.$el.innerText = "Voir Moins";
                window.scrollBy({ top: 100, left: 0, behavior: 'smooth' });
            }else if (this.isHidden===true){
                this.$refs.btnPlusDesktip.$el.innerText = "Voir Plus";
                this.$refs.btnPlusMobile.$el.innerText = "Voir Moins";
                window.scrollBy({ top: -100, left: 0, behavior: 'smooth' });
            }
    },
    goToDemo(){
      this.$router.push({ path: '/plateforme/demo' })
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="less" scoped>
.bg-home {
    position: relative;
    background-image: url(../../assets/img/plateform/bg-home.png);
    background-color: #1f222b;
    background-position: center center;
    .home-center {
        padding: 100px 0px 150px 0px;
    }
}
.home-center {
    display: table;
    width: 100%;
    height: 100%;
}
.home-desc-center {
    display: table-cell;
    vertical-align: middle;
}

.home-title h5 {
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 4px;
    font-weight : 700;
}
.home-title h1 {
    font-size: 60px!important;
    color: #fff;
}

.home-title h2 {
    font-size: 40px!important;
    color: #fff;
}

.home-title p {
    font-weight: 300;
}
h1, h2, h3, h4, h5, h6 {
    font-family: "Rethink Sans", sans-serif;
}

.lh-base {
    line-height: 1.5 !important;
    font-size: 2.75rem;
}

.text-muted {
    font-size: 16px;
    line-height: 1.6;
    font-weight: 350;
    color: #000000!important;
    line-height: 1.6;
}

.img-fluid {
    max-width: 100%;
    height: auto;
}

.play-icon-circle {
    background: #fff;
    height: 36px;
    width: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 50%;
    display: inline-block;
    color: #1f222b;
}

.f-18 {
    font-size: 18px!important;
}

.rethink {
    font-family: "Rethink Sans", sans-serif;
    font-weight: 500;
    font-size: 18px!important;
}


.rounded {
    border-radius: 0.375rem;
}

.border-primary {
    border-color: #ffa409 !important;
}
.text-primary {
    color: #ffa409 !important;
}
.card-services-height {
  height: 100%!important;
}

.gap-3 {
    gap: 1rem !important;
}
.bg-shape {
//background-image: url(/src/assets/img/plateform/bg-home.png);
  background-image: url("../../assets/img/plateform/bg-home.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  //border-radius: 0px;
}

.bg-primary {
  background-color: #ffa409 !important;
}
.bg-secondary {
  background-color: #6a9bc1!important;
}

.btn.btn-primary {
  background-color: #ffa409 !important;
  border: 1px solid #ffa409 !important;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: rgb(255, 164, 9);
  border-bottom: 3px solid rgb(238.5, 150.2743902439, 0) !important;
  color: #fff !important;
}
/********** Home ************/


.home-center {
  display: table;
  width: 100%;
  height: 100%;
}

.home-desc-center {
  display: table-cell;
  vertical-align: middle;
}

.home-title {
  h1 {
    font-size: 60px;
  }
  h3 {
    letter-spacing: 2px;
  }

  h5 {
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 4px;
    font-weight: 700;
  }
}

.play-icon-circle {
  background: #fff;
  height: 36px;
  width: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 50%;
  display: inline-block;
  color: #1f222b;
}

.mouse-down {
  .down-scroll {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -30px;
    z-index: 1;
    i {
      width: 48px;
      height: 48px;
      background: #fff;
      display: inline-block;
      line-height: 48px;
      border-radius: 50%;
      box-shadow: 1px 5px 40px -15px #000000;
    }
  }
}

/*********** About *************/

.about-content {
  h4 {
    line-height: 1.4;
    max-width: 590px;
  }
}

/*********** Features ***********/

.feautures-icon {
  i {
    display: inline-block;
    width: 42px;
    height: 42px;
    text-align: center;
    line-height: 42px;
    border-radius: 7px;
  }
}

/********** Services ***********/

.services-icon {
  &:after {
    content: '';
    position: absolute;
    top: 13px;
    left: 37px;
    width: 42px;
    height: 42px;
    margin: 0px auto;
    border-radius: 6px;
    z-index: -2;
  }
}

/********** Testimonial **********/

.testi-indicators {
  img {
    width: 40px !important;
    height: 40px !important;
    margin-right: 5px;
    margin-left: 5px;
    //opacity: 0.4;
    border-radius: 50%;
    border: 3px solid #fff !important;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.5s;
  }
  .active {
    opacity: 1;
  }
}

/********** Team ***********/

.team-box {
  border-radius: 8px;
  overflow: hidden;
  box-shadow:
    0 10px 50px rgba(#292e49, 0.03),
    0 10px 40px rgba(#fff, 0.03);
}

/********** Pricing **********/

.pricing-header {
  h4 {
    letter-spacing: 2px;
  }
}

.pricing-table {
  border-radius: 12px;
  border: 2px solid rgba(#000000, 0.04);
}

/********** Clients ***********/

.client-images {
  img {
    max-height: 94px;
    width: auto !important;
    margin: 10px auto;
    opacity: 0.6;
    transition: all 0.5s;
    &:hover {
      opacity: 0.9;
    }
  }
}

/********* Responsive ***********/

@media (min-width: 200px) and (max-width: 768px) {
  .home-title {
    h3 {
      font-size: 26px;
    }
  }
  .mouse-down {
    .down-scroll {
      top: 99px;
    }
  }
  .pull-none {
    float: none !important;
    text-align: center;
  }
}

@media (max-width: 425px) {
  .watch-video {
    > a {
      span {
        display: none;
      }
    }
  }
  .carousel-inner {
    min-height: 385px;
  }
  .carousel-indicators {
    li {
      width: 50px;
      height: 50px;
    }
  }
  .carousel-indicators {
    .active {
      width: 70px;
      height: 70px;
    }
  }
}































//
// Helper
//

.section {
  padding-top: 90px;
  padding-bottom: 90px;
  position: relative;
}

.section-sm {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
  position: relative;
}

.bg-overlay {
  position: absolute;
  background-color: rgba(#0f1f3e, 0.8);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.bg-overlay-2 {
  position: absolute;
  background-color: rgba(#fff, 0.9);
  backdrop-filter: blur(4px);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.title h3 {
  font-size: 26px;
}

.title p.subtitle {
  letter-spacing: 4px;
  font-weight: 600;
  font-family: 'Rethink Sans', sans-serif;
}

.f-12 {
  font-size: 12px;
}

.f-13 {
  font-size: 13px;
}

.f-14 {
  font-size: 14px;
}

.f-15 {
  font-size: 15px;
}

.f-16 {
  font-size: 16px;
}

.f-17 {
  font-size: 17px;
}

.f-18 {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}

a.text-custom:hover {
  color: #0f1f3e;
}

.text-light-custom {
  color: darken(#ced4da, 15%);
}

.modal-backdrop {
  background-color: #000000;
}

/**BACK TO TOP**/

.back-to-top-btn {
  position: fixed;
  padding: 0px 5px !important;
  bottom: 10px;
  right: 20px;
  display: none;
  text-align: center;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;

  i {
    font-size: 22px;
    line-height: 30px;
  }
}

#mkLightboxContainer {
  z-index: 999;
}

.icon {
  height: 30px;
  width: 30px;
}

.icon-bg {
  height: 40px;
  width: 40px;
  background-color: #ffa50942 !important
}

.icon-bg-text {
  height: 40px;
  width: 40px;
  background-color: #ffa409 !important
}

.icon-lg {
  height: 50px;
  width: 50px;
  background-color: rgba(#ffa409, 0.1);
}

.img-part {
  &::after {
    content: '';
    position: absolute;
    right: 128px;
    height: 300px;
    width: 300px;
    bottom: 75%;
    background-color: rgba(#ffa409, 0.4);
    margin: 0 auto;
    border-radius: 50%;
    -webkit-transform: translateY(50%);
    transform: translateY(50%);
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    z-index: -1;

    @media (max-width: 568.98px) {
      display: none;
    }
  }
}

.form-check-input {
  &:checked {
    background-color: #ffa409;
    border-color: #ffa409;
  }

  &:focus {
    border: 1px solid #ced4da;
  }
}

.testi-swiper {
  .swiper-slide img {
    width: revert-layer;
    height: revert-layer;
  }
}

.testi-indicators {
  .swiper-slide {
    width: auto !important;
    background: transparent !important;
  }
}

.btn-toggle {
  color:#ffa409;
  margin-top:-6px;
  margin-left: -8px;
  text-transform: none;
  font-weight: 300;
  font-size: 20px;
}
.btn-toggle-mobile {
  color:#ffa409;
  margin-top:-6px;
  margin-left: -13px;
  text-transform: none;
  font-weight: 300;
  font-size: 15px;
}
.animate-demo-button {
   animation: scroll-down 3s infinite alternate;
  cursor: pointer;

  @keyframes scroll-down {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(2vh);
    }
  }
}
</style>

